export const notificationKey = item => `${item.channel}:${item.notification_id}`;
export const combineNotifications = (messages = [], research = []) => [...new Map([
  ...messages.map(item => ({...item, channel: 'messages'})),
  ...research.map(item => ({...item, channel: 'markets'})),
].filter(item => item.notification_id).map(item => [notificationKey(item), item])).values()]
  .sort((a, b) => (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0));

export function notificationSection(item) {
  if (item.channel === 'markets' || ['report_ready', 'watchlist_update', 'runway_alert'].includes(item.type)) return 'Research';
  if (item.metadata?.conversation_id || item.data?.conversation_id || item.type === 'direct') return 'Messages';
  return 'Workspace';
}

export function groupNotifications(items) {
  const groups = new Map();
  for (const item of items) {
    // Group only an explicit invitation identity. Never infer identity from an email,
    // title, or similar wording; distinct notices must remain distinct.
    const invitation = item.type === 'access_follow_up' && item.metadata?.grant_id;
    const key = invitation ? `grant:${item.metadata.grant_id}` : notificationKey(item);
    if (!groups.has(key)) groups.set(key, {key, section: notificationSection(item), items: [], latest: item});
    const group = groups.get(key);
    group.items.push(item);
    if (invitation && Number(item.metadata?.milestone_day || 0) > Number(group.latest.metadata?.milestone_day || 0)) group.latest = item;
  }
  return [...groups.values()].map(group => ({...group, unread: group.items.filter(item => !item.read).length}));
}

export function applyAcknowledgements(snapshot, acknowledged, allMessages = false) {
  const keys = new Set(acknowledged.map(notificationKey));
  const result = {...snapshot};
  for (const channel of ['messages', 'markets']) {
    const source = snapshot[channel];
    if (!source) continue;
    const notices = source.notifications || [];
    const removed = notices.filter(item => !item.read && keys.has(`${channel}:${item.notification_id}`)).length;
    result[channel] = {...source,
      unread_count: allMessages && channel === 'messages' ? 0 : Math.max(0, (source.unread_count || 0) - removed),
      notifications: notices.map(item => (allMessages && channel === 'messages') || keys.has(`${channel}:${item.notification_id}`) ? {...item, read: true} : item),
    };
  }
  return result;
}
